"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _FullScreenMediaButton.FullScreenMediaButton;
  }
});
var _FullScreenMediaButton = require("./FullScreenMediaButton");